module.exports = __webpack_public_path__ + "img/shy.ec8bfd99.gif";